import _regeneratorRuntime from "/data/maven/.jenkins/workspace/web/web/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getToken } from '@/utils/auth';
import * as api from '@/api/persionInfo.js';
export default {
  data: function data() {
    var _this = this;

    var testEmail = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(rule, item, callback) {
        var re;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/g;

                if (!item) {
                  _context.next = 4;
                  break;
                }

                if (re.test(item)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", callback(new Error('电子邮箱格式不正确')));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function testEmail(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    var emailValidator = function emailValidator(rule, value, callback) {
      if (value) {
        var valueList = value.split(",");
        valueList.map(function (item) {
          testEmail(rule, item, callback);
        });
        callback();
      } else {
        callback();
      }
    };

    var validatePass = function validatePass(rule, value, callback) {
      if (_this.ruleForm.linkmanIdeType) {
        switch (_this.ruleForm.linkmanIdeType) {
          case '01':
            var exp = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9X]$/;

            if (exp.test(value)) {
              callback();
            } else {
              callback(new Error('身份证号输入不正确'));
            }

            break;

          case '02':
            var exp2 = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9X]$/;

            if (exp2.test(value)) {
              callback();
            } else {
              callback(new Error('户口簿证件号输入不正确'));
            }

            break;

          case '03':
            var exp3 = /^([a-zA-z]|[0-9]){5,17}$/;

            if (exp3.test(value)) {
              callback();
            } else {
              callback(new Error('护照证件号输入不正确'));
            }

            break;

          case '04':
            var exp4 = /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/;

            if (exp4.test(value)) {
              callback();
            } else {
              callback(new Error('军官证证件号输入不正确'));
            }

            break;

          case '05':
            var exp5 = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9X]$/;

            if (exp5.test(value)) {
              callback();
            } else {
              callback(new Error('驾驶执照证件号输入不正确'));
            }

            break;

          case '06':
            if (value) {
              callback();
            } else {
              callback(new Error('请输入返乡证号'));
            }

            break;

          case '07':
            if (value) {
              callback();
            } else {
              callback(new Error('请输入复原/退伍证号码'));
            }

            break;

          default:
            callback();
        }
      } else {
        callback(new Error('选择证件类型'));
      }
    };

    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== _this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    var validatePassWord = function validatePassWord(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== _this.userForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    var validatePass3 = function validatePass3(rule, value, callback) {
      if (_this.ruleForm.authPersonIdeType) {
        switch (_this.ruleForm.authPersonIdeType) {
          case '01':
            var exp = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9X]$/;

            if (exp.test(value)) {
              callback();
            } else {
              callback(new Error('身份证号输入不正确'));
            }

            break;

          case '02':
            var exp2 = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9X]$/;

            if (exp2.test(value)) {
              callback();
            } else {
              callback(new Error('户口簿证件号输入不正确'));
            }

            break;

          case '03':
            var exp3 = /^([a-zA-z]|[0-9]){5,17}$/;

            if (exp3.test(value)) {
              callback();
            } else {
              callback(new Error('护照证件号输入不正确'));
            }

            break;

          case '04':
            var exp4 = /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/;

            if (exp4.test(value)) {
              callback();
            } else {
              callback(new Error('军官证证件号输入不正确'));
            }

            break;

          case '05':
            var exp5 = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9X]$/;

            if (exp5.test(value)) {
              callback();
            } else {
              callback(new Error('驾驶执照证件号输入不正确'));
            }

            break;

          case '06':
            var exp6 = _this.ruleForm.authPersonIdeNo;
            console.log('是否输入了值', exp6);

            if (exp6) {
              callback();
            } else {
              callback(new Error('请输入返乡证'));
            } // callback()


            break;

          case '07':
            var exp7 = _this.ruleForm.authPersonIdeNo;

            if (exp7) {
              callback();
            } else {
              callback(new Error('请输入复原或退伍号码'));
            }

          default:
            callback();
        }
      } else {
        callback(new Error('选择证件类型'));
      }
    };

    return {
      inputType: 'password',
      inputTypes: 'text',
      readonly: false,
      readonlyConfirm: false,
      newPwdReadOnly: false,
      rePwdReadOnly: false,
      ishyx: false,
      isxyx: false,
      isllx: false,
      loing_box: false,
      isRight: false,
      //是否授信
      getRightDia: false,
      //授权成功弹框
      pickerOptions0: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      isNew: 0,
      tableData: [{
        insuranceCompanyCode: '',
        companys: [],
        companyCode: ''
      }],
      idType: [],
      insuranceCompanyCode: [],
      //保险公司
      getright: false,
      //注册成功-申请授权弹框开关
      idcard: [],
      //下拉框数据，
      limitList: [{
        codeCode: 'Y',
        codeCname: '限制'
      }, {
        codeCode: 'N',
        codeCname: '不限制'
      }],
      //是否限制累计保额List
      // 表单数据
      ruleForm: {
        //平台注册信息
        createTime: '',
        //创建时间
        accountType: '',
        // 账户类型
        businessType: '',
        //100-货物运输保险  101-短期出口贸易信用险
        registAddress: '',
        // 注册地址
        businessAddress: '',
        // 营业地址
        companyType: '',
        //公司类型
        businessNature: '',
        //经营性质
        isListed: '',
        //是否上市
        businessScope: '',
        // 投保业务范围
        businessStartYear: '',
        //出口业务经营历史
        businessImg: '/a/b/c',
        //营业执照
        enterName: '',
        //企业中文名称
        enterEnName: '',
        //企业英文名称
        enterAddress: '',
        //住所
        authPersonName: '',
        //法定代表人
        companyDate: '2016-5-6',
        //成立日期
        orgCode: '123456789123123123',
        //统一社会信用代码证
        businessStartDate: '',
        //营业期限起
        businessEndDate: '',
        //营业期限至
        businessRange: '',
        //营业范围
        // 上面不可修改
        authPersonIdeType: '',
        //法定代表人证件类型
        authPersonIdeNo: '',
        //法定代表人证件号码
        customsRegisterCode: '',
        //海关十位编码
        //联系人信息
        linkmanName: '',
        //联系人姓名
        linkmanIdeType: '',
        //联系人证件类型
        linkmanIdeNo: '',
        //联系人证件号码
        linkmanMobile: '',
        //移动电话
        electronicDocumentsEmail: '',
        //电子单证发送邮箱
        linkmanEmail: '',
        //电子邮箱
        linkmanAddress: '',
        //联系地址
        linkmanPhone: '',
        //联系电话
        //系统信息
        password: '',
        //密码
        confirmPassword: '' //确认密码

      },
      accountApplicationDtos: [0],
      //此处值不做显示用，仅用于显示table
      userForm: {
        oldPassword: '',
        userName: '',
        companyName: '',
        roleName: '',
        //系统信息
        password: '',
        //密码
        confirmPassword: '' //确认密码

      },
      fileList: [],
      businessTypeList: [],
      accountTypeSelect: [{
        codeCode: '1',
        codeCname: '金融保险板块'
      }, {
        codeCode: '2',
        codeCname: '金融银行板块'
      }],
      businessTypeSelect: [],
      isListedSelect: [{
        codeCode: '0',
        codeCname: '否'
      }, {
        codeCode: '1',
        codeCname: '是'
      }],
      companyTypeSelect: [],
      businessNatureSelect: [],
      surePwd: '',
      //确认密码
      // 表单验证规则
      rules3: {
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }, {
          pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,18}$/g,
          message: '密码为数字，小写字母，大写字母，特殊字符，至少包含三种，长度为 8 - 18位'
        }],
        oldPassword: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }, {
          pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,18}$/g,
          message: '密码为数字，小写字母，大写字母，特殊字符，至少包含三种，长度为 8 - 18位'
        }],
        confirmPassword: [{
          required: true,
          validator: validatePassWord,
          trigger: 'blur'
        }]
      },
      rules: {
        eenterName: [{
          required: true,
          message: '请输入企业中文名称',
          trigger: 'change'
        }],
        orgCode: [{
          required: true,
          message: '请输入统一社会信用代码证',
          trigger: 'change'
        }, {
          pattern: /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g,
          message: '18位信用代码格式不正确'
        }],
        linkmanName: [{
          required: true,
          message: '请输入联系人姓名',
          trigger: 'change'
        }, {
          pattern: /^[^0-9]{0,}$/,
          message: '联系人姓名格式不正确'
        }],
        linkmanIdeType: [{
          required: true,
          message: '请选择联系人证件类型',
          trigger: 'change'
        }],
        linkmanIdeNo: [{
          required: true,
          message: '请输入证件号码',
          trigger: 'blur'
        }, {
          required: true,
          validator: validatePass,
          trigger: 'change'
        }],
        linkmanPhone: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'change'
        }, {
          max: 15,
          message: '最大长度为15个字符',
          trigger: 'change'
        }],
        linkmanEmail: [{
          required: true,
          message: '请输入电子邮箱',
          trigger: 'change'
        }, {
          required: true,
          validator: emailValidator,
          trigger: 'change'
        }],
        linkmanMobile: [{
          required: true,
          message: '请输入移动电话',
          trigger: 'change'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '移动电话格式不正确'
        }],
        surePwd: [{
          required: true,
          message: '请再次输入密码',
          trigger: 'change'
        }],
        accountType: [{
          required: true,
          message: '请选择企业开户申请',
          trigger: 'change'
        }],
        enterEnName: [{
          required: false,
          message: '请选输入企业英文名称',
          trigger: 'blur'
        }],
        registAddress: [{
          required: false,
          message: '请输入注册地址',
          trigger: 'blur'
        }],
        businessAddress: [{
          required: false,
          message: '请输入经营地址',
          trigger: 'blur'
        }],
        companyDate: [{
          required: false,
          message: '请输入成立日期',
          trigger: 'blur'
        }],
        businessStartDate: [{
          required: false,
          message: '请输入营业期限起',
          trigger: 'blur'
        }],
        businessEndDate: [{
          required: false,
          message: '请输入营业期限至',
          trigger: 'blur'
        }],
        businessRange: [{
          required: false,
          message: '请输入营业范围',
          trigger: 'blur'
        }],
        companyType: [{
          required: false,
          message: '请选择公司类型',
          trigger: 'change'
        }],
        businessNature: [{
          required: false,
          message: '请选择经营性质',
          trigger: 'change'
        }],
        isListed: [{
          required: false,
          message: '请选择是否上市公司',
          trigger: 'change'
        }],
        businessScope: [{
          required: false,
          message: '请输入投保业务范围',
          trigger: 'change'
        }]
      },
      rules1: {
        enterName: [{
          required: true,
          message: '请输入企业中文名称',
          trigger: 'change'
        }],
        orgCode: [{
          required: true,
          message: '请输入统一社会信用代码证',
          trigger: 'change'
        }, {
          pattern: /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g,
          message: '18位信用代码格式不正确'
        }],
        linkmanName: [{
          required: true,
          message: '请输入联系人姓名',
          trigger: 'change'
        }, {
          pattern: /^[^0-9]{0,}$/,
          message: '联系人姓名格式不正确'
        }],
        linkmanIdeType: [{
          required: false,
          message: '请选择联系人证件类型',
          trigger: 'change'
        }],
        linkmanIdeNo: [{
          required: false,
          message: '请输入证件号码',
          trigger: 'change'
        }],
        linkmanPhone: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'change'
        }, {
          max: 15,
          message: '最大长度为15个字符',
          trigger: 'change'
        }],
        linkmanEmail: [{
          required: true,
          message: '请输入电子邮箱',
          trigger: 'change'
        }, {
          required: true,
          validator: emailValidator,
          trigger: 'change'
        }],
        electronicDocumentsEmail: [{
          validator: emailValidator,
          trigger: 'blur'
        }],
        linkmanMobile: [{
          required: true,
          message: '请输入移动电话',
          trigger: 'change'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '移动电话格式不正确'
        }],
        surePwd: [{
          required: true,
          message: '请再次输入密码',
          trigger: 'change'
        }],
        accountType: [{
          required: true,
          message: '请选择企业开户申请',
          trigger: 'change'
        }],
        enterEnName: [{
          required: true,
          message: '请选输入企业英文名称',
          trigger: 'change'
        }],
        registAddress: [{
          required: true,
          message: '请输入注册地址',
          trigger: 'change'
        }],
        businessAddress: [{
          required: true,
          message: '请输入经营地址',
          trigger: 'change'
        }],
        companyDate: [{
          required: true,
          message: '请输入成立日期',
          trigger: 'change'
        }],
        businessStartDate: [{
          required: true,
          message: '请输入营业期限起',
          trigger: 'change'
        }],
        businessEndDate: [{
          required: true,
          message: '请输入营业期限至',
          trigger: 'change'
        }],
        businessRange: [{
          required: true,
          message: '请输入营业范围',
          trigger: 'change'
        }],
        companyType: [{
          required: true,
          message: '请选择公司类型',
          trigger: 'change'
        }],
        businessNature: [{
          required: true,
          message: '请选择经营性质',
          trigger: 'change'
        }],
        isListed: [{
          required: true,
          message: '请选择是否上市公司',
          trigger: 'change'
        }],
        businessScope: [{
          required: true,
          message: '请输入投保业务范围',
          trigger: 'change'
        }]
      },
      rules2: {
        // 两个都选
        enterName: [{
          required: true,
          message: '请输入企业中文名称',
          trigger: 'change'
        }],
        orgCode: [{
          required: true,
          message: '请输入统一社会信用代码证',
          trigger: 'blur'
        }, {
          pattern: /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g,
          message: '18位信用代码格式不正确'
        }],
        linkmanName: [{
          required: true,
          message: '请输入联系人姓名',
          trigger: 'blur'
        }, {
          pattern: /^[^0-9]{0,}$/,
          message: '联系人姓名格式不正确'
        }],
        linkmanIdeType: [{
          required: true,
          message: '请选择联系人证件类型',
          trigger: 'change'
        }],
        linkmanIdeNo: [{
          required: true,
          message: '请输入证件号码',
          trigger: 'blur'
        }],
        linkmanPhone: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }, {
          max: 15,
          message: '最大长度为15个字符',
          trigger: 'change'
        }],
        linkmanEmail: [{
          required: true,
          message: '请输入电子邮箱',
          trigger: 'blur'
        }, {
          required: true,
          validator: emailValidator,
          trigger: 'blur'
        }],
        electronicDocumentsEmail: [{
          validator: emailValidator,
          trigger: 'blur'
        }],
        linkmanMobile: [{
          required: true,
          message: '请输入移动电话',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '移动电话格式不正确'
        }],
        password: [{
          required: false,
          message: '请输入密码',
          trigger: 'blur'
        }, {
          pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,18}$/g,
          message: '密码为数字，小写字母，大写字母，特殊字符，至少包含三种，长度为 8 - 18位'
        }],
        confirmPassword: [{
          required: false,
          message: '请再次输入密码',
          trigger: 'blur'
        }],
        accountType: [{
          required: true,
          message: '请选择企业开户申请',
          trigger: 'change'
        }],
        enterEnName: [{
          required: false,
          message: '请输入企业英文名称',
          trigger: 'blur'
        }],
        registAddress: [{
          required: false,
          message: '请输入注册地址',
          trigger: 'blur'
        }],
        businessAddress: [{
          required: false,
          message: '请输入经营地址',
          trigger: 'blur'
        }],
        companyDate: [{
          required: false,
          message: '请输入成立日期',
          trigger: 'blur'
        }],
        businessStartDate: [{
          required: false,
          message: '请输入营业期限起',
          trigger: 'blur'
        }],
        businessEndDate: [{
          required: false,
          message: '请输入营业期限至',
          trigger: 'blur'
        }],
        businessRange: [{
          required: false,
          message: '请输入营业范围',
          trigger: 'blur'
        }],
        companyType: [{
          required: false,
          message: '请选择公司类型',
          trigger: 'change'
        }],
        businessNature: [{
          required: false,
          message: '请选择经营性质',
          trigger: 'change'
        }],
        isListed: [{
          required: false,
          message: '请选择是否上市公司',
          trigger: 'change'
        }],
        businessScope: [{
          required: false,
          message: '请输入投保业务范围',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    console.log('路由地址：', this.$route);

    if (this.$store.state.user.userinfo.userType == '01') {
      if (this.$route.params.firstLogin) {
        this.$alert('请录入出单授信企业信息', '提示', {
          confirmButtonText: '确定',
          center: true,
          callback: function callback(action) {}
        });
      }

      api.getComp().then(function (res) {
        //   this.idcard = [...res]
        _this2.insuranceCompanyCode = Object.assign([], res);
      }); // 获取用户信息

      this.getuserinfo(); // 获取证件类型

      api.getData().then(function (res) {
        _this2.idcard = Object.assign([], res);
      }); //码表所需参数

      var data = {
        codeType: 'businessNature'
      }; //经营性质

      api.getDataCodeAndName(data).then(function (res) {
        _this2.businessNatureSelect = Object.assign([], res);
      }); //公司类型

      var data1 = {
        codeType: 'companyType'
      };
      api.getDataCodeAndName(data1).then(function (res) {
        _this2.companyTypeSelect = Object.assign([], res);
      });
    } else {
      this.getInsuranceCompanyUser();
    }
  },
  methods: {
    changAttrConfirm: function changAttrConfirm(e, type) {
      var _this3 = this;

      if (type === 'focus') {
        if (e) {
          e.stopPropagation();
          e.preventDefault();
        }

        setTimeout(function () {
          _this3.readonlyConfirm = false;
        }, 100);
      } else {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }

        this.readonlyConfirm = true;
      }
    },
    changAttr: function changAttr(e, type) {
      var _this4 = this;

      if (type === 'focus') {
        if (e) {
          e.stopPropagation();
          e.preventDefault();
        }

        setTimeout(function () {
          _this4.readonly = false;
        }, 100);
      } else {
        if (e) {
          e.stopPropagation();
          e.preventDefault();
        }

        this.readonly = true;
      }
    },
    clickEvtConfirm: function clickEvtConfirm() {
      var _this5 = this;

      if (this.$refs.confirmPassword) {
        this.$refs.confirmPassword.$refs.input.onmousedown = function (evt) {
          if (evt) {
            evt.preventDefault();
            evt.stopPropagation();
          }

          if (_this5.ruleForm.confirmPassword === '' || _this5.readonly) {
            _this5.$refs.confirmPassword.$refs.input.blur();

            setTimeout(function () {
              _this5.$refs.confirmPassword.$refs.input.focus();
            }, 0);
          }

          return false;
        };
      }
    },
    clickEvt: function clickEvt() {
      var _this6 = this;

      if (this.$refs.password) {
        this.$refs.password.$refs.input.onmousedown = function (evt) {
          if (evt) {
            evt.preventDefault();
            evt.stopPropagation();
          }

          if (_this6.ruleForm.password === '' || _this6.readonly) {
            _this6.$refs.password.$refs.input.blur();

            setTimeout(function () {
              _this6.$refs.password.$refs.input.focus();
            }, 0);
          }

          return false;
        };
      }
    },
    accountTypeChange: function accountTypeChange(val) {
      var _this7 = this;

      if (val != undefined && val != null && val != '') {
        //--后续如果有账户类型追加，此处业务类型的CODETYPE需要根据其value拼接，基础数据需要追加
        var data = {
          codeType: 'businessType' + val
        };

        if (val == '1') {
          //经营性质
          api.getDataCodeAndName(data).then(function (res) {
            _this7.businessTypeSelect = Object.assign([], res);
          });
        } else {
          this.ishyx = false;
          this.isxyx = false;
          this.isllx = false;
          this.businessTypeList = '';
          this.businessTypeSelect = [];
        }
      } else {
        this.ishyx = false;
        this.isxyx = false;
        this.isllx = false;
        this.businessTypeList = '';
        this.businessTypeSelect = [];
      }

      console.log('-------' + val);
    },
    businessTypeChange: function businessTypeChange(val) {
      var _this8 = this;

      this.ishyx = false;
      this.isxyx = false;
      this.isllx = false;
      console.log(val);

      if (val.length > 0) {
        val.map(function (item, i) {
          if (item == '100') {
            _this8.ishyx = true;
          } else if (item == '101') {
            _this8.isxyx = true;
          } else if (item == '102') {
            _this8.isllx = true;
          }
        });
      }
    },
    //获取保险公司登录信息
    getInsuranceCompanyUser: function getInsuranceCompanyUser() {
      var _this9 = this;

      api.getInsuranceCompanyInfo({
        userId: this.$store.state.user.userinfo.userId
      }).then(function (res) {
        _this9.userForm = Object.assign({}, res);
      });
    },
    // 获取用户信息
    getuserinfo: function getuserinfo() {
      var _this10 = this;

      api.getInfo({
        userId: this.$store.state.user.userinfo.userId
      }).then(function (res) {
        res.sysCreditDtoList.forEach(function (item) {
          item.companys = [{
            companyCode: item.companyCode,
            companyName: item.companyCodeName
          }];
        });

        if (res.accountType) {
          var data = {
            codeType: 'businessType' + res.accountType
          };
          api.getDataCodeAndName(data).then(function (res) {
            _this10.businessTypeSelect = Object.assign([], res);
          });
        } else {
          _this10.businessTypeSelect = [];
        }

        _this10.isNew = res.sysCreditDtoList.length;
        _this10.ruleForm = Object.assign({}, res);
        _this10.ruleForm.isLimit = res.isLimit;

        if (_this10.ruleForm.businessType != undefined && _this10.ruleForm.businessType != null && _this10.ruleForm.businessType != '') {
          _this10.businessTypeList = _this10.ruleForm.businessType.split(",");
        }

        _this10.businessTypeList.map(function (item, i) {
          if (item == '100') {
            _this10.ishyx = true;
          } else if (item == '101') {
            _this10.isxyx = true;
          } else if (item == '102') {
            _this10.isllx = true;
          }
        });
      });
    },
    // 单行授信
    justRights: function justRights(data, index, type) {
      var _this11 = this;

      if (!data.insuranceCompanyCode) {
        this.$message({
          message: '请选择保险公司',
          type: 'warning'
        });
        return false;
      }

      var name = '';
      var name2 = '';
      this.insuranceCompanyCode.forEach(function (item) {
        if (item.insuranceCompanyCode == data.insuranceCompanyCode) name = item.insuranceCompanyName;
      });
      data.companys.forEach(function (item) {
        if (item.companyCode == data.companyCode) name2 = item.companyName;
      });
      var datas = {
        "applyTime": "",
        "auditTime": "",
        "companyCode": data.companyCode,
        "companyCodeName": name2,
        "creditStatus": data.creditStatus,
        "insuranceCompanyCode": data.insuranceCompanyCode,
        "insuranceCompanyName": name,
        "orgCode": this.$store.state.user.userinfo.orgCode,
        "userId": this.$store.state.user.userinfo.userId,
        type: type
      };
      this.loing_box = true; // this.getRightDia = true

      this.isRight = true;
      api.CreditOne(datas).then(function (res) {
        if (res.rtnCode == '0000') {
          _this11.isRight = false; // this.$message({
          //   // message: res.rtnMsg,
          //   type: 'success'
          // })

          _this11.getRightDia = true; // 重新获取用户信息

          _this11.getuserinfo();
        } else {
          _this11.getRightDia = false;

          _this11.$message({
            message: res.rtnMsg,
            type: 'warning'
          });
        }

        _this11.loing_box = false;
      }, function (res) {
        _this11.loing_box = false;
      });
    },
    // 删除授信行
    deleteLine: function deleteLine(data, index) {
      var _this12 = this;

      if (data.creditStatus == "01") {
        this.$message({
          message: '请与该保险公司解除合约后再删除',
          type: 'warning'
        });
        return false;
      }

      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // if (data.creditStatus == '00'||'02') {
        if (!data.applyTime && (data.creditStatus == '00' || '02')) {
          _this12.ruleForm.sysCreditDtoList.splice(index, 1);
        } else {
          api.deleteLine({
            "insuranceCompanyCode": data.insuranceCompanyCode,
            "userId": _this12.$store.state.user.userinfo.userId
          }).then(function (res) {
            //  this.isNew =this.ruleForm.sysCreditDtoList.length
            _this12.$message({
              type: 'success',
              message: res.rtnMsg
            });

            _this12.getuserinfo();
          });
        }
      }).catch(function () {
        _this12.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    // 授权完成后确认按钮刷新界面
    suerGetright: function suerGetright() {
      var _this13 = this;

      this.getRightDia = false;
      api.getInfo({
        userId: this.$store.state.user.userinfo.userId
      }).then(function (res) {
        res.sysCreditDtoList.forEach(function (item) {
          item.companys = [];
        });
        _this13.isNew = res.sysCreditDtoList.length;
        _this13.ruleForm = Object.assign({}, res);
      });
    },
    checkPassword: function checkPassword(val) {
      if (/^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,18}$/g.test(val)) {
        this.$message({
          message: '密码为数字，小写字母，大写字母，特殊字符，至少包含三种，长度为 8 - 18位',
          type: 'warning'
        });
      }
    },
    // 提交
    submitForm: function submitForm(formName) {
      var _this14 = this;

      var isSubmitForm = true;

      if (this.ruleForm.password || this.ruleForm.confirmPassword) {
        if (!this.ruleForm.password) {
          isSubmitForm = false;
          this.$message({
            message: '请输入密码',
            type: 'warning'
          });
        } else {
          if (!/^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,18}$/g.test(this.ruleForm.password)) {
            isSubmitForm = false;
            this.$message({
              message: '密码为数字，小写字母，大写字母，特殊字符，至少包含三种，长度为 8 - 18位',
              type: 'warning'
            });
          }
        }

        if (!this.ruleForm.confirmPassword && isSubmitForm) {
          isSubmitForm = false;
          this.$message({
            message: '请输入确认密码',
            type: 'warning'
          });
        }

        if (this.ruleForm.password != this.ruleForm.confirmPassword && isSubmitForm) {
          isSubmitForm = false;
          this.$message({
            message: '两次输入密码不一致',
            type: 'warning'
          });
        }
      }

      if (isSubmitForm) {
        var businessTypeList = this.businessTypeList;

        if (businessTypeList != undefined && businessTypeList != null && businessTypeList.length > 0) {
          this.ruleForm.businessType = businessTypeList.join(',');
        } else {
          this.ruleForm.businessType = '';
        }

        if (!this.isxyx) {
          this.ruleForm.businessScope = '';
          this.ruleForm.businessStartYear = '';
        }

        console.log(this.ruleForm.isLimit);

        if (!this.ruleForm.businessType) {
          this.$message({
            message: '请选择需要开通的业务',
            type: 'warning'
          });
        } else {
          this.$refs[formName].validate(function (valid) {
            if (valid) {
              _this14.ruleForm.sysCreditDtoList.forEach(function (item) {
                delete item.companys;
              });

              var data = {};

              if (_this14.isNew < _this14.ruleForm.sysCreditDtoList.length) {
                data = {
                  "businessStartYear": _this14.ruleForm.businessStartYear,
                  "accountType": _this14.ruleForm.accountType,
                  "registAddress": _this14.ruleForm.registAddress,
                  "businessAddress": _this14.ruleForm.businessAddress,
                  "companyType": _this14.ruleForm.companyType,
                  "businessNature": _this14.ruleForm.businessNature,
                  "isListed": _this14.ruleForm.isListed,
                  "businessScope": _this14.ruleForm.businessScope,
                  "businessType": _this14.ruleForm.businessType,
                  "enterName": _this14.ruleForm.enterName,
                  "enterEnName": _this14.ruleForm.enterEnName,
                  "enterAddress": _this14.ruleForm.enterAddress,
                  "authPersonName": _this14.ruleForm.authPersonName,
                  "isLimit": _this14.ruleForm.isLimit,
                  "companyDate": _this14.ruleForm.companyDate,
                  "businessStartDate": _this14.ruleForm.businessStartDate,
                  //营业期限起
                  "businessEndDate": _this14.ruleForm.businessEndDate,
                  //营业期限至
                  "businessRange": _this14.ruleForm.businessRange,
                  //营业范围
                  "customsRegisterCode": _this14.ruleForm.customsRegisterCode,
                  "confirmPassword": _this14.ruleForm.confirmPassword ? _this14.$md5(_this14.ruleForm.confirmPassword) : '',
                  "linkmanAddress": _this14.ruleForm.linkmanAddress,
                  "linkmanEmail": _this14.ruleForm.linkmanEmail,
                  "linkmanIdeNo": _this14.ruleForm.linkmanIdeNo,
                  "linkmanIdeType": _this14.ruleForm.linkmanIdeType,
                  "linkmanMobile": _this14.ruleForm.linkmanMobile,
                  "electronicDocumentsEmail": _this14.ruleForm.electronicDocumentsEmail,
                  "linkmanName": _this14.ruleForm.linkmanName,
                  "linkmanPhone": _this14.ruleForm.linkmanPhone,
                  "orgCode": _this14.ruleForm.orgCode,
                  // authPersonName: this.ruleForm.authPersonName,
                  userId: _this14.ruleForm.userId,
                  authPersonIdeType: _this14.ruleForm.authPersonIdeType,
                  authPersonIdeNo: _this14.ruleForm.authPersonIdeNo,
                  "password": _this14.ruleForm.password ? _this14.$md5(_this14.ruleForm.password) : '',
                  sysCreditDtoList: Object.assign([], _this14.ruleForm.sysCreditDtoList)
                };
              } else {
                data = {
                  "businessStartYear": _this14.ruleForm.businessStartYear,
                  "accountType": _this14.ruleForm.accountType,
                  "registAddress": _this14.ruleForm.registAddress,
                  "businessAddress": _this14.ruleForm.businessAddress,
                  "companyType": _this14.ruleForm.companyType,
                  "businessNature": _this14.ruleForm.businessNature,
                  "isListed": _this14.ruleForm.isListed,
                  "businessScope": _this14.ruleForm.businessScope,
                  "businessType": _this14.ruleForm.businessType,
                  "enterName": _this14.ruleForm.enterName,
                  "enterEnName": _this14.ruleForm.enterEnName,
                  "enterAddress": _this14.ruleForm.enterAddress,
                  "authPersonName": _this14.ruleForm.authPersonName,
                  "isLimit": _this14.ruleForm.isLimit,
                  "companyDate": _this14.ruleForm.companyDate,
                  "confirmPassword": _this14.ruleForm.confirmPassword ? _this14.$md5(_this14.ruleForm.confirmPassword) : '',
                  "linkmanAddress": _this14.ruleForm.linkmanAddress,
                  "linkmanEmail": _this14.ruleForm.linkmanEmail,
                  "linkmanIdeNo": _this14.ruleForm.linkmanIdeNo,
                  "businessStartDate": _this14.ruleForm.businessStartDate,
                  //营业期限起
                  "businessEndDate": _this14.ruleForm.businessEndDate,
                  //营业期限至
                  "businessRange": _this14.ruleForm.businessRange,
                  //营业范围
                  "customsRegisterCode": _this14.ruleForm.customsRegisterCode,
                  // authPersonName: this.ruleForm.authPersonName,
                  "linkmanIdeType": _this14.ruleForm.linkmanIdeType,
                  "linkmanMobile": _this14.ruleForm.linkmanMobile,
                  "electronicDocumentsEmail": _this14.ruleForm.electronicDocumentsEmail,
                  "linkmanName": _this14.ruleForm.linkmanName,
                  authPersonIdeType: _this14.ruleForm.authPersonIdeType,
                  authPersonIdeNo: _this14.ruleForm.authPersonIdeNo,
                  "linkmanPhone": _this14.ruleForm.linkmanPhone,
                  userId: _this14.ruleForm.userId,
                  "orgCode": _this14.ruleForm.orgCode,
                  "password": _this14.ruleForm.password ? _this14.$md5(_this14.ruleForm.password) : ''
                };
              }

              var loading = _this14.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              console.log("----------------------------------");
              api.editInfo(data).then(function (res) {
                loading.close();

                if (res.rtnCode == "0000") {
                  _this14.$message({
                    message: '保存成功',
                    type: 'success'
                  }); // this.$router.push({ name: 'dashboard' })
                  // this.getRightDia = true

                } else {
                  _this14.$message({
                    message: res.rtnMsg,
                    type: 'warning'
                  });
                }

                _this14.getuserinfo();
              });
            } else {
              _this14.$message({
                message: res.rtnMsg,
                type: 'warning'
              });

              return false;
            }
          });
        }
      }
    },
    // 保险公司信息提交
    submitUserForm: function submitUserForm(formName) {
      var _this15 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var data = {
            "userId": _this15.$store.state.user.userinfo.userId,
            "oldPassWord": _this15.userForm.oldPassword ? _this15.$md5(_this15.userForm.oldPassword) : '',
            "newPassWord": _this15.userForm.password ? _this15.$md5(_this15.userForm.password) : '',
            "token": getToken()
          };

          var loading = _this15.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });

          api.editUserInfo(data).then(function (res) {
            loading.close();

            if (res.resultCode == "0000") {
              _this15.$message({
                message: '保存成功',
                type: 'success'
              });

              var scanHref = window.location.href;

              if (scanHref.indexOf("ecargo") != -1) {
                window.location.href = '/ecargo/';
              } else {
                window.location.href = '/';
              } // this.getRightDia = true

            } else {
              _this15.$message({
                message: res.resultMsg,
                type: 'warning'
              });
            }
          });
        } else {
          _this15.$message({
            message: res.rtnMsg,
            type: 'warning'
          });

          return false;
        }
      });
    },
    // 获取机构
    getcompany: function getcompany(index, data) {
      var _this16 = this;

      api.queryAll({
        insuranceCompanyCode: data.insuranceCompanyCode
      }).then(function (res) {
        _this16.ruleForm.sysCreditDtoList[index].companys = Object.assign([], res);
      });
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    // 重置表单 1
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    newinfo: function newinfo() {
      this.ruleForm.sysCreditDtoList.push({
        "applyTime": "",
        "auditTime": "",
        "companyCode": "",
        "companyCodeName": "",
        "creditStatus": "03",
        "insuranceCompanyCode": '',
        "insuranceCompanyName": "",
        "orgCode": this.$store.state.user.userinfo.orgCode,
        "userId": this.$store.state.user.userinfo.userId,
        companys: []
      });
    },
    // 取消信息维护,返回主页
    cancelUserInfo: function cancelUserInfo() {
      this.$router.push({
        path: '/'
      });
    },
    // 取消信息维护,返回主页
    cancelInfo: function cancelInfo() {
      var flag = false;
      var businessTypeListis = true;
      var businessTypeList = this.businessTypeList;

      if (businessTypeList) {
        businessTypeList.map(function (item, i) {
          if (item == '100') {
            console.log(item + '---------------');
            businessTypeListis = false;
          }
        });
      }

      this.ruleForm.sysCreditDtoList.forEach(function (item) {
        if (item.creditStatus == '01') flag = true;
      });
      console.log(this.ruleForm.sysCreditDtoList);

      if (flag || businessTypeListis) {
        this.$router.push({
          path: '/'
        });
      } else {
        this.$message({
          message: '您没有授权，请您先在保险公司预留的邮箱中查看并点击激活链接后，方可激活本次授信申请',
          type: 'warning'
        });
      }
    },
    val_check: function val_check(val) {
      if (val && val != undefined && val != null && val != '') {
        var reg = new RegExp("^[0-9]*$");

        if (val.length < 4) {
          val = '';
        }

        if (val < 1900 || !reg.test(val)) {
          val = '';
        }
      } else {
        val = '';
      }

      this.ruleForm.businessStartYear = val;
    }
  }
};